import { WorkspaceContext } from "@sg-protect/shell";
import { useContext, useMemo } from "react";
import { getPaths } from "../../paths.ts";

// `usePaths` throws without a workspace, and the command palette lives in the shell header, which renders without one.
export function useSearchPaths() {
    const workspaceId = useContext(WorkspaceContext)?.currentWorkspace?.id;

    return useMemo(() => (workspaceId ? getPaths({ workspaceId }) : undefined), [workspaceId]);
}
